// Version: 1.0 - Important Disclaimer Component
import React, { useState } from 'react';
import './Disclaimer.css';

const Disclaimer: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="disclaimer-banner" role="alert">
      <div className="container">
        <div className="disclaimer-content">
          <div className="disclaimer-icon">
            <i className="fa fa-exclamation-triangle"></i>
          </div>
          <div className="disclaimer-text">
            <strong>Important Notice:</strong> This website is a <strong>concept only</strong> and is not affiliated with any emergency room facility. 
            If you are experiencing a medical emergency, please <strong>call 911</strong> or visit your <strong>nearest emergency room</strong> immediately.
          </div>
          <button 
            className="disclaimer-close" 
            onClick={() => setIsVisible(false)}
            aria-label="Close disclaimer"
          >
            <i className="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
